export function isPushNotificationSupported(): boolean {
  return "serviceWorker" in navigator && "PushManager" in window;
}
